module.exports = __webpack_public_path__ + "img/login-img.6642eeb7.jpg";